import styled from "styled-components";

export function Pagination(
   { disabled, currentPage, totalPages, onPageChange, color }: 
   { disabled: boolean, currentPage: number, totalPages: number, onPageChange: (number: number) => void, color?: string }
) {
   const pageNumbers: number[] = [];

   for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
   }
   const renderPageNumbers = () => {
      return pageNumbers.map(number => {
         if (number === 1 || number === totalPages || (number >= currentPage - 1 && number <= currentPage + 1)) {
            return (
               <span
                  key={ number }
                  className={`num ${number === currentPage ? 'active' : ''}`}
                  onClick={() => { if (number !== currentPage && !disabled) onPageChange(number) }}
                  style={{ margin: '0 5px' }}
               >{ number }</span>
            );
         }
         if (number === currentPage - 2 || number === currentPage + 2) {
            return <span key={number}>...</span>;
         }
         return null;
      });
   }

   return (
      <Main $color={ color || '#3E82F8' } className={`pagination ${disabled ? 'disabled' : ''}`}>{ renderPageNumbers() }</Main>
   );
}

const Main = styled.div<{ $color: string }>`
   display: flex;
   justify-content: center;
   align-items: center;
   margin-bottom: 5px;

   &.disabled {
      opacity: 0.65;

      .num:hover {
         cursor: default;
         color: #1E272E;
      }
   }
   .num {
      padding: 2.5px 5px;
      background-color: #F6F6F6;
      border: 1px solid rgba(220, 220, 220);
      border-radius: 5px;
      transition: all .2s ease-in-out;
      
      &.active, &:hover {
         cursor: pointer;
         color: ${({ $color }) => $color }
      }
   }
`;